import React, { useState, useEffect,useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { storage, firestore, auth }  from "../../../firebase/firebase.js";
import {
  collection,
  addDoc,
  getDoc,
  updateDoc,
  query,
  orderBy,
  onSnapshot,
  increment,
  doc,
  arrayUnion,
  setDoc,
  serverTimestamp
} from 'firebase/firestore';

import Button from '../../ui/Button';


import {
  HiHandThumbUp,
  HiHandThumbDown,
  HiBolt,
  HiSparkles,
  HiOutlineFaceSmile,
  HiMiniFaceSmile,
  HiExclamationTriangle
} from 'react-icons/hi2';
import styles from './SpectatorBench.module.css';
import { useAuth } from "../../../utils/AuthContext/authcontext";
import avatar from './../../../assets/default-avatar.svg';
import StatusEditorPopup from "../../StatusEditorPopup/StatusEditorPopup";
import SpectatorMicroBench from "../SpectatorMicroBench/SpectatorMicroBench";


import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
//import 'emoji-mart/css/emoji-mart.css'; // style only once in your app

const reactionIcons = [
  { id: 'up', icon: HiHandThumbUp },
  { id: 'down', icon: HiHandThumbDown },
  { id: 'power', icon: HiBolt },
  { id: 'sparkles', icon: HiSparkles },
  { id: 'alert', icon: HiExclamationTriangle }
];

let spawnId = 0;
const MIN_INTERVAL = 1500; // 1.5 seconds

const teamColor = {
  pro: '#fca311',       // gold
  con: '#ff4d4d',       // red
  neutral: '#ccc'       // gray
};

let uniqueId = 0;

function truncate( str, n, useWordBoundary )
{
  if (str.length <= n) { return str; }
  const subString = str.substr(0, n-1); // the original check
  return (useWordBoundary 
    ? subString.substr(0, subString.lastIndexOf(" ")) 
    : subString) + "\u2026";
};

function getSpectatorColor(uid) {
  /*const palette = [
    '#fca311', '#ff6b6b', '#4ecdc4', '#3a86ff',
    '#ffbe0b', '#8338ec', '#ff006e', '#00b4d8',
  ];*/
  const palette = [
    '#b4dfc2', '#aa5c5c', '#4ecdc4', '#3a86ff',
    '#695596', '#a288c6', '#b4718e', '#00b4d8',
  ];
  let hash = 0;
  for (let i = 0; i < uid.length; i++) {
    hash = uid.charCodeAt(i) + ((hash << 5) - hash);
  }
  return palette[Math.abs(hash) % palette.length];
}

const SpectatorBench = ({ arenaMeta, arenaId, spectators = []  }) => {
  const { user: currentUser} = useAuth();
  const [activeEditor, setActiveEditor] = useState(null);
  const [statusDraft, setStatusDraft] = useState({});
  const [formattedReactions, setformattedReactions] = useState([]);
  const [newspecators, setnewspecators] = useState([]);
  const [emojiPickerOpen, setEmojiPickerOpen] = useState(null);
  const [floatingIcons, setFloatingIcons] = useState([]);
  const [editing, setEditing] = useState(false);
  const [statusText, setStatusText] = useState('Watching');
  const lastSent = useRef(0);
  const emojiClickRef = useRef(false);
  const inputRefs = useRef({});
  const caretPos = useRef({});  
  
  const currentUserSpectator = spectators?.find(s => s.uid === currentUser.uid);
  const otherSpectators = spectators?.filter(s => s.uid !== currentUser.uid);

	const handleBlur = (uid) => {
	  //Wait a tick to see if emoji picker was clicked
	  setTimeout(() => {
		if (!emojiClickRef.current) {
		  //handleStatusSave(uid);
		}
	  }, 100);
	};

	const handleEmojiSelect = (emoji, uid) => {
	  const currentText = statusDraft[uid] || '';
	  const input = inputRefs.current[uid];
	  const caret = caretPos.current[uid] ?? currentText.length;

	  const before = currentText.slice(0, caret);
	  const after = currentText.slice(caret);
	  const updated = `${before}${emoji.native}${after}`;

	  //console.log(before, after, updated)

	  setStatusDraft((prev) => {
		caretPos.current[uid] = caret + emoji.native.length;
		return {
		  ...prev,
		  [uid]: updated,
		};
	  });

	  // Focus & move caret
	  setTimeout(() => {
		if (input) {
		  input.focus();
		  input.setSelectionRange(caretPos.current[uid], caretPos.current[uid]);
		}
	  }, 0);
	};

	const handleStatusSave = async (uid, val) => {
		const newStatus = val || 'Watching'; //|| statusDraft[uid]
		await updateSpectatorStatus(arenaId, uid, newStatus);
		setActiveEditor(null);
		setEmojiPickerOpen(null);
	};

	useEffect(() => {
		if(arenaId == undefined) return;
		const q = query(collection(firestore, 'arenas', arenaId, 'reactions'));
		return onSnapshot(q, (snapshot) => {
		  snapshot.docChanges().forEach(change => {
			if (change.type === 'modified') {
			  const {type, team, reactions, userId} = change.doc.data();
			  triggerTrail(type, team, reactions, userId)
			}
			else if(change.type === 'added')
			{
				const {reactions, userId} = change.doc.data();
				var fr = formattedReactions;
				const total = Object.values(reactions || {}).reduce((sum, v) => sum + v, 0);
				fr[userId] = total;
				setformattedReactions(fr);
			}
		  });
		});
	}, [arenaId]);

  useEffect(() => {
	const geteactions = [];
	spectators.forEach((s,i) => {
	
		geteactions.push(s);
		/*geteactions.push({uid: `${s.uid} ${i}`,
		email: s.email,
		username: s.username || '',
		profilePicture: s.profilePicture || '',});
		geteactions.push({uid: `${s.uid} ${i}`,
		email: s.email,
		username: s.username || '',
		profilePicture: s.profilePicture || '',});
		geteactions.push({uid: `${s.uid} ${i}`,
		email: s.email,
		username: s.username || '',
		profilePicture: s.profilePicture || '',});
		geteactions.push({uid: `${s.uid} ${i}`,
		email: s.email,
		username: s.username || '',
		profilePicture: s.profilePicture || '',});
		geteactions.push({uid: `${s.uid} ${i}`,
		email: s.email,
		username: s.username || '',
		profilePicture: s.profilePicture || '',});
		geteactions.push({uid: `${s.uid} ${i}`,
		email: s.email,
		username: s.username || '',
		profilePicture: s.profilePicture || '',});
		geteactions.push({uid: `${s.uid} ${i}`,
		email: s.email,
		username: s.username || '',
		profilePicture: s.profilePicture || '',});
		geteactions.push({uid: `${s.uid} ${i}`,
		email: s.email,
		username: s.username || '',
		profilePicture: s.profilePicture || '',});
		geteactions.push({uid: `${s.uid} ${i}`,
		email: s.email,
		username: s.username || '',
		profilePicture: s.profilePicture || '',});
		geteactions.push({uid: `${s.uid} ${i}`,
		email: s.email,
		username: s.username || '',
		profilePicture: s.profilePicture || '',});*/
	});
	setnewspecators(geteactions);
  }, [spectators]);


  useEffect(() => {
	const otherSpectators = spectators?.filter(s => s.uid !== currentUser.uid);
	const currentUserSpectator = spectators?.find(s => s.uid === currentUser.uid);
	if(currentUserSpectator) {
		setStatusDraft({[currentUserSpectator.uid]: currentUserSpectator.status});
	}
  }, []);

   const updateSpectatorStatus = async (arenaId, uid, newStatus) => {
	  if(arenaId == undefined) return;
	  const arenaRef = doc(firestore, 'arenas', arenaId);
	  const arenaSnap = await getDoc(arenaRef);
	  const arenaData = arenaSnap.data();

	  const spectators = arenaData?.spectators || [];
	  const updatedSpectators = spectators.map(s => s.uid === uid ? { ...s, status: truncate(newStatus, 500,true) } : s);
	  await updateDoc(arenaRef, {
		spectators: updatedSpectators
	  });
	};

  const handleReaction = async (type) => {
    if(arenaId == undefined) return;
	const now = Date.now();
    if (now - lastSent.current < 1500) return;
    lastSent.current = now;
    const user = currentUser;
    const team = getSpectatorColor(currentUser.uid);
	await setDoc(doc(firestore, 'arenas', arenaId, 'reactions', user.uid), {
      type, reactions: {[`${type}`]: increment(1)} , team, userId: user?.uid, updatedAt: Date.now()}, { merge: true });
  };

  const handleSubmit = async () => {
	await updateSpectatorStatus(arenaId, currentUser.uid, statusText);
	setEditing(false);
  };

  const triggerTrail = (type, team = 'pro', reactions, userId) => {
    const id = uniqueId++;
	var fr = formattedReactions;
	const total = Object.values(reactions || {}).reduce((sum, v) => sum + v, 0);
	fr[userId] = total;
	setformattedReactions(fr);
    setFloatingIcons(prev => [...prev, { id, type, team }]);
    setTimeout(() => setFloatingIcons(prev => prev.filter(i => i.id !== id)), 1200);
  };

  return (
  <>
	<div key={currentUser.uid} className={styles.bench}>
	<div className={styles.specbenchdiv}><h2 className={styles.specbench}>Spectator's bench</h2><h2 className={currentUserSpectator == null || currentUserSpectator == undefined ? `${styles.specbench} ${styles.specbenchnone}` :  styles.specbench}>Live Reactions</h2></div>
	{newspecators.length > 0 ? <div className={styles.row}>
		<SpectatorMicroBench 
		arenaMeta={arenaMeta}
		spectators={newspecators}
		currentUser={currentUser}
		statusDraft={statusDraft}    // track previous status for changes
		handleStatusUpdate={handleStatusSave}
		reactions={formattedReactions}
		onOpenEditor={uid => setActiveEditor(uid)}/>
		
        {<div className={styles.reactions}>
		  {reactionIcons.map(({ id, icon: Icon }) => {
			const color = getSpectatorColor(currentUser.uid);
			if(currentUserSpectator == null || currentUserSpectator == undefined) return null;
			return (
            <span key={id} onClick={() => handleReaction(id)} style={{ color }} className={styles.iconReaction}>
              <Icon size={22} />
            </span>
          );
		  })}
		  <AnimatePresence>
			{floatingIcons.map(({ id, type, team }) => {
			  const Icon = reactionIcons.find(r => r.id === type).icon;
			  const color = team;
			  
			  return (
				<motion.div
				  key={id}
				  className={styles.floatingIcon}
				  style={{ color }}
				  initial={{ opacity: 0, y: 0, scale: 1 }}
				  animate={{ opacity: 1, y: -80, scale: 1.5 }}
				  exit={{ opacity: 0, scale: 0.8 }}
				  transition={{ duration: 1.2, ease: 'easeOut' }}>
				  <Icon size={24} />
				</motion.div>
			  );
			})}
		  </AnimatePresence>
		  </div>}
	</div> : <><div className={styles.nospecators}>No one is watching yet...</div> <div className={styles.invitespecators}><Button className={styles.invitespecatorsbutton}>Invite a Specator</Button></div></>}
	</div>
	 {activeEditor && (
	  <StatusEditorPopup
		uid={activeEditor}
		svalue={statusDraft[activeEditor] ?? ''}
		onClose={() => setActiveEditor(null)}
		onChange={(val) => {setStatusDraft({ ...statusDraft, [activeEditor]: val })}}
		onSave={(val) => {
		  handleStatusSave(activeEditor, val);
		  setActiveEditor(null);
		}}
	  />
	)}
	</>
  );
  
  return (
  <>
    <div key={currentUser.uid} className={styles.bench}>
      <div className={styles.row}>
        <div className={styles.avatars}>
		  <div className={styles.avatar}>
		  {spectators.map((s) => {
			const name = s?.username || s?.email || 'Unknown';
			const color = getSpectatorColor(s.uid || name);
            const isSelf = currentUser?.uid === s.uid;
			return (
			  <div  className={styles.spectatorWrapper} >
				  <div className={styles.avatarWrapper} key={s.uid || name}>
					<img
					  src={s.profilePicture || avatar}
					  alt={name}
					  className={styles.avatar}
					  style={{ borderColor: color }}/>
					<span className={styles.tooltip}>{name}</span>
					<div style={{ color: color }} className={styles.username}>{isSelf == true ? 'You' : s.username}</div>
				  </div>
					  <>
						  <div className={styles.status} style={{ color }} onClick={() => isSelf && setActiveEditor(s.uid)}>
							{s.status || 'Watching'}
						  </div>
						  
						{/*false && isSelf && activeEditor === s.uid ? (
						  <div className={styles.inputGroup}>
							<textarea
							  ref={(el) => (inputRefs.current[s.uid] = el)}
							  value={statusDraft[s.uid] ?? s.status ?? ''}
							  onChange={(e) => {
								const value = e.target.value.slice(0, 120);
								setStatusDraft({ ...statusDraft, [s.uid]: value });
							  }}
							  onBlur={() => handleBlur(s.uid)}
								style={{ height: 'auto' }}
								rows={1}
								onInput={(e) => {
								  e.target.style.height = 'auto';
								  e.target.style.height = `${e.target.scrollHeight}px`;
								}}
							  onSelect={(e) => {
								caretPos.current[s.uid] = e.target.selectionStart;
							  }}
							  className={styles.textarea}
							  rows={2}
							  placeholder="Set your status..."
							/>
							<div className={styles.inputFooter}>
							  <div className={styles.actions}>
								<Button className={styles.emojiBtn}
								  onMouseDown={() => {
									emojiClickRef.current = true;
									setEmojiPickerOpen(emojiPickerOpen === s.uid ? null : s.uid);
									setTimeout(() => (emojiClickRef.current = false), 200);
								  }}>
								  <HiMiniFaceSmile size={18} />
								</Button>
								<Button className={styles.clearBtn} onClick={() => {
									setStatusDraft({ ...statusDraft, [s.uid]: '' });
									caretPos.current[s.uid] = 0; }}>
								  clear
								</Button>
								<Button className={styles.saveBtn} onClick={() => handleStatusSave(s.uid)} >
								 save
								</Button>
							  <span className={styles.counter}>
								{(statusDraft[s.uid] || '').length}/120
							  </span>
							  </div>
							</div>
							{emojiPickerOpen === s.uid && (
							  <div className={styles.pickerContainer}>
								<Picker data={data} onEmojiSelect={(emoji) => handleEmojiSelect(emoji, s.uid)}  theme="dark" />
							  </div>
							)}
						  </div>
						) : (
						  <div className={styles.status} style={{ color }} onClick={() => isSelf && setActiveEditor(s.uid)}>
							{s.status || 'Watching'}
						  </div>
						)*/}
					  </>
			   </div>
			);
		  })}
		  </div>
        </div>

        {currentUserSpectator != null && currentUserSpectator != undefined ? <div className={styles.reactions}>
          {reactionIcons.map(({ id, icon: Icon }) => {
			const color = getSpectatorColor(currentUser.uid);
			return (
            <span key={id} onClick={() => handleReaction(id)} style={{ color }} className={styles.iconReaction}>
              <Icon size={22} />
            </span>
          );
		  })}
		  <AnimatePresence>
			{floatingIcons.map(({ id, type, team }) => {
			  
			  const Icon = reactionIcons.find(r => r.id === type).icon;
			  const color = team;
			  return (
				<motion.div
				  key={id}
				  className={styles.floatingIcon}
				  style={{ color }}
				  initial={{ opacity: 0, y: 0, scale: 1 }}
				  animate={{ opacity: 1, y: -80, scale: 1.5 }}
				  exit={{ opacity: 0, scale: 0.8 }}
				  transition={{ duration: 1.2, ease: 'easeOut' }}>
				  <Icon size={24} />
				</motion.div>
			  );
			})}
		  </AnimatePresence>
		  </div>: <> </>}
      </div>
    </div>
	 {activeEditor && (
	  <StatusEditorPopup
		uid={activeEditor}
		svalue={statusDraft[activeEditor] ?? ''}
		onClose={() => setActiveEditor(null)}
		onChange={(val) => {setStatusDraft({ ...statusDraft, [activeEditor]: val })}}
		onSave={(val) => {
		  handleStatusSave(activeEditor, val);
		  setActiveEditor(null);
		}}
	  />
	)}
	</>
  );
};

export default SpectatorBench;


